<template>
<div>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('shop.closeing')" center width="600px"
    :close-on-click-modal="false" @close="whenDialogClose" :show-close="!!order">
    <div class="dialog-con df-l-c-fs w100p">

      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-ct" v-if="!!order">
          <div class="f-l test">{{$t('order.orderNo')}}{{order.orderNo}}{{order.subOrderId?'-'+order.subOrderId:''}}{{$t('shop.faildReason')}}{{order.stripeErrorMsg}}{{$t('shop.pleaseEdit')}}</div>
          <div class="edit-btn df-c-ct f-xs f-white _themebackground ml20" @click.stop.prevent="tipClickHandler">{{order.tipsFee|toprice(2)}}</div>
        </div>
        <div class="mydialog df-c-ct" v-else>
          <div class="f-l">{{$t('shop.waitingCloseing')}}</div>
        </div>
      </div>

      <div class="dialog-btm w100p df-c-sa" v-if="!!order">
        <div class="themebtn" @click="submit">{{$t('shop.continue')}}</div>
      </div>
    </div>
  </el-dialog>

  <DialogTip ref="DialogTip" :scan_canLeave_open="false" @submitDialog="submitDialogTip" />

</div>
</template>

<script>
export default {
  name: 'DialogTipError',
  data() {
    return {
      isShowDialog: false,

      order: null,
    }
  },
  methods: {
    open(order) {
      this.order = order
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.order = null
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
    },
    submit() {
      this.$emit('submit')
    },
    tipClickHandler() {
      this.$refs.DialogTip.open(this.order.id, 0, this.order.tipsFee)
    },
    submitDialogTip(val) {
      // console.log(`%cval:`, 'color: #00f;', val)
      this.order.tipsFee = val.tipsFee
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.dialog-square /deep/.el-dialog{min-height: 300px;} // 默認500px
.mydialog{
  // padding: 80px 0;
  padding: 80px;
  .test{word-break: keep-all;line-height: 30px;}
  .edit-btn{width: 80px;height: 30px;flex-shrink: 0;}
}
</style>